export default __webpack_public_path__ + "static/media/2.676187fa.jpg";